import React, { useState } from "react";
import './newBuilding.css'
import { styled } from "@mui/material";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Stepper, Step, StepLabel } from "@mui/material";
import PageOne from "./PageOneBuilding";
import PageTwo from "./PageTwoBuilding";
import PageThree from "./PageThreeBuilding";

const useStyles = styled((theme) => ({
    root: {
        backgroundColor: "#1C1E24",
        padding: 20,
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

function getSteps() {
    return ["", "", ""];
}

function getStepContent(stepIndex, handleNext, handleBack) {
    switch (stepIndex) {
        case 0:
            return <PageOne handleNext={handleNext} />;
        case 1:
            return <PageTwo handleNext={handleNext} handleBack={handleBack} />;
        case 2:
            return <PageThree handleBack={handleBack} />;
        default:
            return "Unknown stepIndex";
    }
}

export default function MultiPageForm() {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const steps = getSteps();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <div className="newComplexContainer">
            <div className="newcTiltle"><h2>New Building</h2></div>
            <div className="new">
                <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <div>
                        {activeStep === steps.length ? (
                            <div className="notif">
                                <p>All steps completed</p>
                            </div>
                        ) : (
                            <div className="Contents">
                                {getStepContent(activeStep, handleNext, handleBack)}
                                <div>
                                    <ButtonPolicy
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        className={classes.backButton}
                                    >
                                        Back
                                    </ButtonPolicy>
                                    <ButtonPolicy variant="contained" color="primary" onClick={handleNext}>
                                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                                    </ButtonPolicy>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
